// extracted by mini-css-extract-plugin
export var container = "Tags-module--container--6274d";
export var tag = "Tags-module--tag--ed19f";
export var tooltip = "Tags-module--tooltip--fbfd4";
export var hiddenTags = "Tags-module--hiddenTags--d5300";